import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnDestroy } from '@angular/core';
// import { NzNotificationService, NzMessageService, UploadFile, UploadXHRArgs } from 'ng-zorro-antd';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { concatMap, startWith, take ,  filter, map } from 'rxjs/operators'
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  RequirementDO,
  /* Document Manager */
  AppConfig,
  EntityDocumentDO,
  IntimationService,
  AppMetadataHandler,
} from 'app';

import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin, Observable, Observer } from 'rxjs';
import { environment } from 'environments/environment';
import * as moment from 'moment/moment';
import { IntBulkProcLogDO } from 'app/BaseFramework/shared/models/IntBulkProcessLog.model';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';



@Component({
  selector: 'app-new-bulk',
  templateUrl: './new-bulk.component.html',
  styleUrls: ['./new-bulk.component.scss']
})
export class NewBulkComponent implements OnInit {
  documentsFromServerMini: any;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    public interactService: InteractService,
    private commonUtility: CommonUtilty,
    private notification: NzNotificationService,
    private intimationService:IntimationService,
    /* Document Manager */
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private msg: NzMessageService,
    private appConfig: AppConfig,
    public appMetadataHandler: AppMetadataHandler
  ) { }

  ngOnInit() {

    this.initUploadVars();
    this.bulkProcDO = new IntBulkProcLogDO();
    this.intializebulkTransaction();
  }

  dataSet = [{}, {}];

  handleFileUpload(data) {
    console.log(data);
  }



  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    'source': environment.applicationSource,
    'hash': '7h1nk[)j',
  });


  BulkIntimationReqResp = {};
  bulkProcDO = new IntBulkProcLogDO();
  
  @Input() source: string
  @Input() batchId: string

  fileListTemp: NzUploadFile[] = [];
  uploading: boolean = false;
  fileUploadEndpoint: string;
  fileGroupUploadEndpoint: string;
  zipFileUploadEndpoint: string;
  showWarningRibbon = false;
  uploadSource: string;

  initUploadVars() {
    // this.fileUploadEndpoint = this.appConfig.baseApiPath + 'bulkIntimation/submit';
    this.fileUploadEndpoint = this.appConfig.baseApiPath + 'bulk/health/submit';
    //this.fileGroupUploadEndpoint = this.appConfig.baseApiPath + 'bulk/health/group/submit';
    // this.fileGroupUploadEndpoint = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/vision-intelligence/document-ocr-form';
    this.fileGroupUploadEndpoint = this.appConfig.baseApiPath + 'policy/invokeSaveWithOCR'
    this.zipFileUploadEndpoint = this.appConfig.baseApiPath + 'bulk/health/uploadZip';
    this.fileFetchEndpointRAW = '/bulk/health/download';
    this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
  }

  fileUploadBefore = (file: NzUploadFile, fileList): boolean => {
    console.log("check upload source: ", this.uploadSource)   //application/x-zip-compressed
    let isFileTypeSupported: Boolean
    if (this.uploadSource == "excel")
      isFileTypeSupported = file.type.includes('application/vnd.ms-excel') || file.type.includes('application/x-zip-compressed') || file.type.includes('application/pdf');
    if (this.uploadSource == "zip")
      isFileTypeSupported = file.type.includes('application/x-zip-compressed')

    if (!isFileTypeSupported) {
      this.msg.error(`Unsupported file type. Please select a excel file`);
      return false;
    } else {
      if (this.uploadSource == "zip")
        this.uploadedFileData.push({ "fileName": file.name, "fileType": file.type })
      this._toggleRefreshComponent();
      this.preUploadImgChecks(file).subscribe(
        n => {
          if (n) { //n = true => All passed
            this.fileListTemp = []; //reset
            this.fileListTemp.push(file); //push
            if(this.uploadSource == "excel")
              this.fileUpload(file);
            if(this.uploadSource == "zip")
              this.uploadMultipleFiles(file);
            return true;
          }
        },
        e => { },
        () => { }
      );
      return true;
    }
  };

  fileRemove = (file: NzUploadFile): boolean => {
    //alert('Cannot remove uploaded file. Please upload new file to replace');
    //return false;
    return true;
  };

  preUploadImgChecks = (file: NzUploadFile) => {
    return new Observable((observer: Observer<boolean>) => {
      /* Bypass checks * /
      observer.next(true);
      observer.complete();
      return;
      /* */
      /* Max File Size */
      const maxFileSize = 4; /* in MB */

      /* Supported file types */

      // const isSupportedFileType = file.type.includes('application/vnd.ms-excel') || file.type.includes('application/pdf');
      let isFileTypeSupported: Boolean
      if (this.uploadSource == "excel")
        isFileTypeSupported = file.type.includes('application/vnd.ms-excel') || file.type.includes('application/x-zip-compressed') || file.type.includes('application/pdf');
      if (this.uploadSource == "zip")
        isFileTypeSupported = file.type.includes('application/x-zip-compressed')

      if (!isFileTypeSupported) {
        this.msg.error(`Unsupported file type. Please select a Excel file or PDF file`);
        observer.complete();
        // this.initDocumentData(this.documents, this.requirements); //reset
        return;
      }
      const fileSizeOK = file.size / 1024 / 1024 < maxFileSize;
      if (!fileSizeOK) {
        this.msg.error(`Image must smaller than ${maxFileSize} MB`);
        observer.complete();
        //this.initDocumentData(this.documents, this.requirements); //reset
        return;
      }
      observer.next(isFileTypeSupported && fileSizeOK);
      observer.complete();
      return;
    });
  };

  showUpload = true;
  excelFormData = new FormData();
  uploadedFile;

  fileUpload(file): void {
    let url = this.fileUploadEndpoint;
    const formData = new FormData();
    this.uploading = true;
    this.showWarningRibbon = true
    // Set Data

    this.bulkProcDO.batchStatusCd = "STARTED";
    let options = {
      reportProgress: true,
      headers: this.headers,
    };
    this.BulkIntimationReqResp['stagingProcDO'] = this.bulkProcDO;
    this.excelFormData.append('json', JSON.stringify(this.BulkIntimationReqResp));
    // Attach File(s) [1 in this case]
    //this.fileListTemp.forEach((file: any) => { formData.append('file', file) });
    this.excelFormData.append('file', file)
    this.uploadedFile = file;
    // const req = new HttpRequest('POST', url, formData, options);
    // this.http
    //   .request(req)
    //   .pipe(filter(e => e instanceof HttpResponse))
    //   .subscribe(
    //     (e: {}) => {
    //       let response: any = e;
    //       if (response.body['exceptionDOList'] && response.body['exceptionDOList'].length > 0) {
    //         response.body.exceptionDOList.forEach(element => {
    //           element.exceptionMaster.exceptionMsgDO.forEach(innerElement => {
    //             this.msg.error(innerElement.message);
    //           });
    //         });
    //         this.uploading = false;
    //         this.fileListTemp = [];
    //         this.showUpload = false;
    //         setTimeout(() => { this.showUpload = true; }, 200);
    //       }
    //       else {
    //         this.uploading = false;
    //         this.msg.success('Upload successful');
    //         this.fileListTemp = [];
    //         this.showUpload = false;
    //         setTimeout(() => { this.showUpload = true; }, 200);

    //       }

    //       // this.initDocumentData(this.documents, this.requirements);
    //     }, e => {
    //       this.uploading = false;
    //       this.msg.error('Upload failed');
    //     }
    //   );
  }
  processingOCR: boolean = false;
  
  uploadExcel(){
    this.processingOCR = true;
    let options = {
      reportProgress: true,
      headers: this.headers,
    };
    //  = this.fileUploadEndpoint;
    let url

    if(this.interactService.bulkUploadType == "Excel Upload")
      url = this.fileUploadEndpoint
    else if (this.interactService.bulkUploadType == "OCR Upload")
      url = this.fileGroupUploadEndpoint
    else
      url = this.fileUploadEndpoint

      let base64OCR = null;
      const reader = new FileReader();
      reader.readAsDataURL(this.uploadedFile);
      reader.onload = () => {
        base64OCR = reader.result
        console.log("base 64 string for file: ",reader.result);
      

      const headers = { 'Content-Type': 'application/json' };
      let request = {
          "product_type": "LIFE_Claims_Dev",
          "business_process": "FWARISKANALYSIS",
          "module_name": "VisionIntelligence",
          "file": base64OCR,
          "authToken": this.apiRequestService.token,
          "applicationType":"nbu",
          "confidenceThreshold": 0.40,
          "apiKey": "c63ac4e0a3ae4803a562d20b8df0311d",
      }
     
      if(this.interactService.bulkUploadType !== "OCR Upload"){
        this.http.post<any>(url, request, { headers })
          .subscribe(e => {
              this.processingOCR = false;
              let response = this.commonUtility.deepCopy(e);
              this.notification.success('Proposal Initiated!',`Proposal generated successfully: ${e.Proposals.toString()}`);
              //this.msg.success(`Claim generated successfully: ${e.Claims.toString()}`, { nzDuration: 4000 });
              setTimeout(() => { this.router.navigate(['/app/nbu/proposal/bulkUpload']) },10);
              if (response.body && response.body['exceptionDOList'] && response.body['exceptionDOList'].length > 0) {
                response.body.exceptionDOList.forEach(element => {
                  element.exceptionMaster.exceptionMsgDO.forEach(innerElement => {
                    this.msg.error(innerElement.message);
                  });
                });
                this.uploading = false;
                this.fileListTemp = [];
                this.showUpload = false;
                this.showWarningRibbon = false
                setTimeout(() => { this.showUpload = true; }, 200);
              }
              else {
                this.uploading = false;
               // this.msg.success(`File uploaded successfully batch id is ${response.body.stagingProcDO['batchId']}`, { nzDuration: 4000 });
                this.fileListTemp = [];
                this.showUpload = false;
                this.showWarningRibbon = false
                setTimeout(() => { this.showUpload = true; }, 200);
                //setTimeout(() => { this.router.navigate(['/app/claims/intimation/bulkUpload']) },10);
              }
    
              // this.initDocumentData(this.documents, this.requirements);
            }, e => {
              this.processingOCR = false;
              this.uploading = false;
              this.msg.error('Upload failed');
    
            });
          };
      }
      if(this.interactService.bulkUploadType == "OCR Upload"){
        let pathVariables = [];
        pathVariables.push(this.uploadedFile.name);
        this.apiRequestService.getCallWithAPIMapper('invokeSaveWithOCR', null, null, pathVariables).subscribe(e=>{
          this.processingOCR = false;
              let response = this.commonUtility.deepCopy(e);
              // this.notification.success('Proposal Initiated!',`Proposal generated successfully: ${e.Proposals.toString()}`);
              //this.msg.success(`Claim generated successfully: ${e.Claims.toString()}`, { nzDuration: 4000 });
              // setTimeout(() => { this.router.navigate(['/app/nbu/proposal/bulkUpload']) },10);
              if (response.body && response.body['exceptionDOList'] && response.body['exceptionDOList'].length > 0) {
                response.body.exceptionDOList.forEach(element => {
                  element.exceptionMaster.exceptionMsgDO.forEach(innerElement => {
                    this.msg.error(innerElement.message);
                  });
                });
                this.uploading = false;
                this.fileListTemp = [];
                this.showUpload = false;
                this.showWarningRibbon = false
                setTimeout(() => { this.showUpload = true; }, 200);
              }
              else {
                this.uploading = false;
               // this.msg.success(`File uploaded successfully batch id is ${response.body.stagingProcDO['batchId']}`, { nzDuration: 4000 });
               if(response && response['Proposals'] && this.commonUtility.isArrayIterable(response['Proposals']) && response['Proposals'][0])
                this.msg.success(`Proposal created successfully with proposal number as '${response['Proposals'][0]}'`, { nzDuration: 4000 });
               else  this.msg.success(`Proposal created successfully`, { nzDuration: 4000 });
                this.fileListTemp = [];
                this.showUpload = false;
                this.showWarningRibbon = false
                setTimeout(() => { this.showUpload = true; }, 200);
                //setTimeout(() => { this.router.navigate(['/app/claims/intimation/bulkUpload']) },10);
              }
    
              // this.initDocumentData(this.documents, this.requirements);
            }, e => {
              this.processingOCR = false;
              this.uploading = false;
              this.msg.error('Upload failed');
              })
      }
  }


  uploadMultipleFiles(file) {
    let url = this.zipFileUploadEndpoint;
    const formData = new FormData();
    this.uploading = false;

    // Set Data
    this.bulkProcDO.batchStatusCd = "STARTED";
    let options = {
      reportProgress: true,
      headers: this.headers,
    };
    this.BulkIntimationReqResp['stagingProcDO'] = this.bulkProcDO;
    this.BulkIntimationReqResp['batchId'] = this.batchId;
    formData.append('json', JSON.stringify(this.BulkIntimationReqResp));
    // Attach File(s) [1 in this case]
    //this.fileListTemp.forEach((file: any) => { formData.append('file', file) });
    formData.append('file', file)
    const req = new HttpRequest('POST', url, formData, options);
    this.http
      .request(req)
      .pipe(filter(e => e instanceof HttpResponse))
      .subscribe(
        (e: {}) => {
          let response: any = e;
          if (response.body['exceptionDOList'] && response.body['exceptionDOList'].length > 0) {
            response.body.exceptionDOList.forEach(element => {
              element.exceptionMaster.exceptionMsgDO.forEach(innerElement => {
                this.msg.error(innerElement.message);
              });
            });
            this.uploading = false;
            this.fileListTemp = [];
            // this.showUploadZIP = false;
            // setTimeout(() => { this.showUploadZIP = true; }, 200);
          }
          else {
            this.uploading = false;
            this.msg.success(`Zip File uploaded successfully`, { nzDuration: 4000 });
            this.fileListTemp = [];
            // this.showUploadZIP = false;
            // setTimeout(() => { this.showUploadZIP = true; }, 200);

          }

          // this.initDocumentData(this.documents, this.requirements);
        }, e => {
          this.uploading = false;
          this.msg.error('Upload failed');

        }
      );
  }

  uploadedFileData =[];
  refreshComponentToggle: boolean = true;
  private _toggleRefreshComponent() {
    this.refreshComponentToggle = false;
    setTimeout(() => { this.refreshComponentToggle = true; }, 300);
  }

  bulkMetaDataList = [];
  metaDataEntityGuid=null;
  intializebulkTransaction() {
    this.interactService.bulktransactionSubject$.pipe(take(1)).subscribe(res => {
      this.bulkMetaDataList = res.IO;
      if(this.bulkMetaDataList && this.bulkMetaDataList.length > 0)
         this.metaDataEntityGuid=this.bulkMetaDataList[0].entityGuid;
      console.log(JSON.stringify(this.bulkMetaDataList) + " ramesh");

    });
  }


  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }


  getTimeString(rawTime) {
    let timeString
    timeString = this.commonUtility.serverDOtoUIDOsetTime(rawTime);
    return new Date(timeString)
  }

  metadataArray = [];
  processRecord() {
    if(this.metadataArray.length == 0)
    this.notification.error('No records selected', 'Please select at least one record');
    else
    {
        this.intimationService.processBulkIntimation(this.metadataArray).
        subscribe(resp => {
        console.log("working............");      
        });
    }
   

}
  
  emitSelectedIntimation(event, data) {
    if (event) {
      let indexFound = this.metadataArray.findIndex(item => {
          if (item)
            return item === data;
        })
      if (indexFound === -1) {
        this.metadataArray.push(data)
      }
    }
    else {

      let output = this.metadataArray.filter(item => {
        if (item)
          return item !== data;
      }) || []
      this.metadataArray = output;
    }
  }
  guessFileName(url) {
    if (!url) { return ''; }
    const character = (url.indexOf('\\') > -1) ? '\\' : '/';
    return url.substring(url.lastIndexOf(character) + 1);
  }
  guessFileExtension(url) {
    const filename = this.guessFileName(url);
    return String(filename.substring(filename.lastIndexOf('.') + 1)).toLowerCase();
  }
  guessOriginalFileName(fileObj) {
    if (typeof fileObj !== 'object') { return ''; }
    return (fileObj.entityImageName) ? fileObj.entityImageName : this.guessFileName(fileObj.imageURL);
  }
  guessOriginalFileNameFromImgURL(imgUrl) {
    if (!this.documentsFromServerMini || !this.documentsFromServerMini.length) return '';
    const fileObj = this.documentsFromServerMini.find(d => d.imageURL === imgUrl); /* unfiltered copy of documentsFromServer */
    if (typeof fileObj === 'object') { return this.guessOriginalFileName(fileObj); }
    return '';
  }

  /* Guess filetype IF extension is not found in file URL (Eg: filenet case) */
  guessFileExtensionFromMIME(url) {
    // (1) Take from entityImageMimeType (2) Split `/` (3) Return extension
  }

  /* Generic function to guess file type */
  /* NOW ALSO USED as for finding 'supported files' *** */
  guessFileType(url): string {
    let extension = url;
    if (url && url.length > 4) extension = this.guessFileExtension(url);
    /* Find file type */
    if (['jpg', 'png', 'x-png', 'jpeg', 'pjpeg', 'jfif', 'gif', 'tiff', 'tif', 'bmp', 'webp'].includes(extension)) return "Image";
    else if (['pdf', 'doc', 'docx'].includes(extension)) return "Document";
    else if (['mp4', 'mov', 'avi', 'mpeg', 'webm'].includes(extension)) return "Video";
    else if (['mp3', 'wav', 'ogg'].includes(extension)) return "Audio";
    else if (['xls', 'xlsx', 'xlt', 'xltx', 'xlsm', 'xlsb', 'xla', 'xlam', 'xltm'].includes(extension)) return "Sheet";
    else if (['zip', 'gz', 'rar', 'rar5'].includes(extension)) return "Archive";
    else if (['eml', 'msg'].includes(extension)) return "Email";
    else if (['html', 'htm'].includes(extension)) return "HTML";
    return "File"; // un-supported
  }
  fileIsPreviewable(url): boolean {
    let supportedFormats = [ // Add all supported formats here
      'jpg', 'png', 'jpeg', 'jfif', 'gif', 'bmp', 'webp', //Images
      'tif', 'tiff', // TIFF images (requires decoder plugin)
      'mp4', 'mov', 'avi', 'mpeg', 'webm', // Videos
      'mp3', 'wav', 'ogg', //Audio
      'pdf', // PDF Doc
      'html', 'htm', // HTML Files
    ];
    let extension = this.guessFileExtension(url);
    return supportedFormats.includes(extension);
  }

  downloadFile(blob: any, filename: string): boolean {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
    return true;//url;
  }

  
  fileFetchEndpointRAW: string;
  fileFetchEndpoint: string;
  modalFilePreview: boolean = false;
  previewDataStream: any = null;
  previewDataStreamUnsanitized: string = '';
  previewFileUrl: string = '';
  fileIsBeingDownloaded: boolean = false;

  fetchFile(url, action: string = 'return'): void | boolean | any {

    // Basic checks and resets
    this.previewDataStream = null;
    this.previewFileUrl = url;
   // if (!url) return false;

    let body = { "imageURL": url };
    let guessedFilename = this.guessOriginalFileNameFromImgURL(url);

    /* No need to fetch file if file is not previewable */
    if ('preview' == action && !this.fileIsPreviewable(url)) {
      this.previewDataStream = null;
      this.modalFilePreview = true; //open the modal anyway, and show "download"
      return false;
    }

    this.modalFilePreview = ('preview' == action);

    this.fileIsBeingDownloaded = true;
    

    /* Get file contents (bin) */
    this.http.get<Blob>(this.fileFetchEndpoint, {
      headers: this.headers,
      responseType: 'blob' as 'json'
    })
      .pipe(map(res => {
        if (!res) { console.log(" ----- EMPTY FILE RESPONSE ----- "); return; }
            this.fileIsBeingDownloaded = false;
            this.downloadFile(res, "REIMBURSEMENT.xls");
      }))
      .subscribe(d => { }, e => { console.log("Document Fetch http err", e) });
  }

  fileRemoveZIP = (file: NzUploadFile): boolean => {
    //alert('Cannot remove uploaded file. Please upload new file to replace');
    //return false;
    return true;
  };
}
